import styled from 'styled-components';

export const ButtonsWrapper = styled.div`
  position: absolute;
  right: 16px;
  max-width: 215px;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 4px;
  border-radius: 8px;
  border: 1px solid var(--border-soft);
  background-color: var(--background-soft);
`;
